import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import assetUrl from '../../assetUrl';
import './LanguagesSection.css';

export default function LanguagesSection() {
  const { t } = useLanguage();
  const l = t.homeLanguages;

  return (
    <section className="section home-languages" id="home-languages">
      <div className="container">
        <header className="home-languages-head">
          <h2>{l.title}</h2>
          <p>{l.intro}</p>
        </header>

        <ul className="home-languages-grid">
          {l.featured.map((lang, i) => (
            <li key={lang.name} className="home-language-card" style={{ '--hl-i': i }}>
              <img
                className="home-language-flag"
                src={assetUrl(`/images/flags/${lang.code}.svg`)}
                alt=""
                loading="lazy"
                decoding="async"
              />
              <span className="home-language-name">{lang.name}</span>
            </li>
          ))}
        </ul>

        <div className="home-languages-cta">
          <Link to="/languages" className="btn btn-outline">
            {l.moreLanguages}
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
